import React, { useCallback, useEffect, Suspense, useState } from "react";
import { Text, Title } from "@mantine/core";

import AppNavBar from "../components/AppNavBar";
import { postFigmaAuthData, getFigmaFrameFromLink } from "../api";

// we need to store the permission key in XANO and then it can be shared with any collaborating user

const AuthCallbackPage = () => {

    const [stateValid, setStateValid] = useState(null)
    const urlParams = new URLSearchParams(window.location.search);
    const stateParam = urlParams.get('state');
    const codeParam = urlParams.get('code');

    const [imageRequested, setImageRequested] = useState(false)

    const imageRequestClick = useCallback(() => {
        return getFigmaFrameFromLink().then(() => setImageRequested(true));
    }, [])
 


    const getAccessToken = useCallback(() => {
        return postFigmaAuthData({ code: codeParam })
            .then((res) => {
                setStateValid(true)
                console.log(res)
                return imageRequestClick();
            })
            .catch((err) => {
                console.error("Figma auth failed", err);
                setStateValid(false);
            });
    }, [codeParam, imageRequestClick])

    useEffect(() => {

        stateParam === localStorage.getItem('figmaState') ? getAccessToken() : setStateValid(false)
    }, [getAccessToken, stateParam]);

    const GridBackground = () => {
        return (
            <div style={{ position: "fixed", left: 0, top: 0, bottom: 0, zIndex: -1, width: "100%", height: "100vh", backgroundImage: 'url("/image/background-grid.png")', backgroundAttachment: "fixed" }}></div>

        )
    }



    return (
        <div>
            <Suspense fallback={<div>Loading... </div>}>
                <GridBackground />
                <div>
                    <div>
                        <AppNavBar pageName={'authorised'} />
                    </div>
                    <div style={{ marginTop: 64, marginBottom: 32 }}>
                        <div style={{ marginLeft: 80 }}>
                            <Title order={1} fw={700}>
                                {stateValid === null ? "Thinking..." : stateValid === true ? "Access authorised!" : "Uh oh something's wrong!"}
                            </Title>
                        </div>
                        <div style={{ marginLeft: 80 }}>
                            <Text fw={700}>
                                We have lift off! You can close this window. Jump back into your project to start using Figma frames in matchboxxr projects.
                                {/* {stateParam} & {localStorage.getItem('figmaState')} */}
                            </Text>
                           
                        </div>
                    </div>
                        {/* <Box sx={{ marginLeft: 10, flexGrow: 1 }}>
                            <button onClick={() => imageRequestClick()}>Request frame</button>
                        </Box> */}
                        {imageRequested && (
                            <img
                                src={localStorage.getItem('figmaImage')}
                                alt="Requested Figma frame preview"
                            />
                        )}
                </div>
            </Suspense>
        </div>
    )
};

export default AuthCallbackPage;